import { AuthProvider } from './components/AuthContext'
import { EventYearProvider } from './components/EventYearContext'
import ProtectedApp from './components/ProtectedApp'
import { ErrorBoundary } from './components/ErrorBoundary'

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <EventYearProvider>
          <ProtectedApp />
        </EventYearProvider>
      </AuthProvider>
    </ErrorBoundary>
  )
}

export default App